/* eslint-disable no-console */
import * as React from 'react';
import { Avatar as DSAvatar } from '@ghq-abi/design-system';

import { useGetProfilePicture } from '../../../entities/Employee/api/useGetProfilePicture';

type AvatarProps = React.ComponentProps<typeof DSAvatar> & {
  employeeId?: string;
  globalId?: string;
};

export function Avatar({ employeeId, globalId, ...rest }: AvatarProps) {
  const { imageSrc } = useGetProfilePicture(globalId ?? '');

  return (
    <DSAvatar
      src={(employeeId || globalId) && imageSrc ? imageSrc : undefined}
      {...rest}
    />
  );
}
